import axios from 'axios';
import { toast } from 'react-toastify';
import store from 'store/index';
import { refreshToken } from 'store/actions';
import querystring from 'query-string';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_V2_URL,
  withCredentials: true,
  paramsSerializer: function (query) {
    return querystring.stringify(query, { arrayFormat: 'bracket' })
  },
});
// Captura de respostas/erros nas requisições
axiosInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;

  }, async function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    let message = (error.response?.data?.error || error.message);
    if (message === "Usuário desconectado.") {
      message = "Tempo de acesso esgotado.\nPor favor, logue-se novamente.";
      toast.error(message, { autoClose: 10000 });
      return Promise.reject(error);
    } else if (message === 'Token Expired' || message === 'Token not provided') {
      return store.dispatch(refreshToken(() => {
        const originalRequestConfig = error.config;
        axiosInstance.request(originalRequestConfig);
      }));
    }
    return Promise.reject(error);
  });

const axiosInstance2 = axios.create({
  baseURL: process.env.REACT_APP_API_V2_URL,
  withCredentials: true,
});

export default axiosInstance;
export const axiosInstanceRefresh = axiosInstance2;
